const MINUTES_PER_DAY = 24 * 60
// 30 free minutes because renteon ¯\_(ツ)_/¯
const FREE_MINUTES = 30

// Rental dates hold business (Europe/Warsaw) wall-clock time in their local fields (see useDateTimeService),
// so the duration is measured on those fields. A raw instant diff would count the DST hour on the fall-back
// weekend (and depend on the browser's timezone), turning e.g. 29 calendar days into 30 billed days.
const toWallClockMinutes = (date: Date) => Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes()) / 60000

export const getRentalDays = (start: Date | string | number, end: Date | string | number): number =>
	Math.ceil((toWallClockMinutes(new Date(end)) - toWallClockMinutes(new Date(start)) - FREE_MINUTES) / MINUTES_PER_DAY)
